export const LIST_ALL = "/v1/appointment/service/list/all";